import UserPaymentDetailsFormContentBankAccountDetailsBankData from '../Common/BankDetails';
import { UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccountProps } from './props';
import styles from './styles.module.scss';

/**
 * UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccount Component
 * This component is responsible for rendering the bank account details specific to Argentine bank accounts.
 * It displays the bank details if available in the validation result.
 *
 * @param {UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccountProps} props - The properties for the component.
 * @param {UserPaymentDetailsValidationResult} props.validationResult - The validation result containing bank account details.
 *
 * @returns {JSX.Element} The rendered component displaying the Argentine bank account details.
 *
 * @example
 * // Usage example:
 * <UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccount validationResult={validationResult} />
 */
export default function UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccount({
  validationResult,
}: UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccountProps) {
  return (
    <div className={styles.container}>
      {validationResult?.bankAccount?.bank && (
        <UserPaymentDetailsFormContentBankAccountDetailsBankData
          bank={validationResult?.bankAccount?.bank}
        />
      )}
    </div>
  );
}
